import React, { useState, useEffect } from "react";
import ShortNameBox from "./ShortNameBox";
import {subjectDuration,getSubjectStatus, formatOnlyDateRange, formatDateRange, calculateTotalMonths} from "../../utils/commonFunction.js";
import moment from "moment";
import MentoredSubject from "./MentoredSubject";
import { useHistory } from "react-router-dom";
import { Heading5, MediumText } from "../common/GlobalElements/Typography.js";
import { tokens } from "../../public/tokens.js";
const stc = require('string-to-color');

const SubjectHeadBox = (props) => {
  const row = props.content;
  const [status, setStatus] = useState(null);
  const [data, setData] = useState(null);
  const history = useHistory()


  const dateFormat = "Do MMM YY";
  return (
    <>
      <div className="lecture-detail-top d-flex justify-content-between  shift-move">
        <div className="lecture-detail-top-left">
          <div className="lecture-bx-info  d-flex">
            <div className="lecture-bx-info-rgt">
              <Heading5 className="mb-0" title={row.name}>{row.name}</Heading5>
              <div className="course-statistics-count text-secondary">
                {props.isAdmin != 1 ? (
                  (() => {
                    if (row.type === "selfplaced" && row.subject_type === "shortcourse") {
                      switch (row.student_intake_status) {
                        case 0:
                          return (
                            <MediumText fontWeight={tokens.typography.fontWeights.regular} as="p" title={formatOnlyDateRange(row?.start, row?.end)}>
                              <i className="fal fa-calendar-clock"></i>
                            </MediumText>
                          );
                        case 1:
                        case 4:
                          return row?.showTargetStart && row?.showTargetEnd ? (
                            (() => {
                              const startDate = moment(row.showTargetStart, dateFormat).unix();
                              const endDate = moment(row.showTargetEnd, dateFormat).unix();
                              return (
                                <MediumText fontWeight={tokens.typography.fontWeights.regular} as="p" title={formatOnlyDateRange(startDate, endDate)}>
                                  <i className="fal fa-calendar-clock"></i>
                                  {formatOnlyDateRange(startDate, endDate)}
                                </MediumText>
                              );
                            })()
                          ) : (
                            "Invalid Date"
                          );                        
                        case 2: 
                        case 3: 
                          const formattedDate = formatOnlyDateRange(moment(row.showTargetStart, dateFormat).unix(), moment(row?.showCompletion, dateFormat).unix())
                          return row?.showTargetStart && row?.showCompletion ? (
                            <MediumText fontWeight={tokens.typography.fontWeights.regular} as="p" title={formattedDate}>
                              <i className="fal fa-calendar-clock"></i>
                              {formattedDate}
                             </MediumText>  
                          ) : (
                            "Invalid Date"
                          );                                             
                          default:
                            return (
                              <MediumText fontWeight={tokens.typography.fontWeights.regular} as="p" title={formatOnlyDateRange(moment(row.showStart, dateFormat).unix() , moment(row.showEnd, dateFormat).unix()) }>
                                <i className="fal fa-calendar-clock"></i>
                                {formatOnlyDateRange(moment(row.showStart, dateFormat).unix() , moment(row.showEnd, dateFormat).unix()) }
                            </MediumText>
                            )
                      }
                    } else if (row.subject_type === "mentored") {

                      switch (row.student_intake_status) {
                        case 0: 
                        return (
                          <MediumText fontWeight={tokens.typography.fontWeights.regular} as="p" title={formatOnlyDateRange(moment(row.showStart, dateFormat).unix() , moment(row.showEnd, dateFormat).unix()) }>
                            <i className="fal fa-calendar-clock"></i>
                            {formatOnlyDateRange(moment(row.showStart, dateFormat).unix() , moment(row.showEnd, dateFormat).unix()) }
                          </MediumText>
                        )  
                        case 1: 
                        case 4: 
                        return (
                          <MediumText fontWeight={tokens.typography.fontWeights.regular} as="p" title={formatOnlyDateRange(moment(row.showTargetStart, dateFormat).unix() , moment(row.showTargetEnd, dateFormat).unix()) }>
                            <i className="fal fa-calendar-clock"></i>
                            {formatOnlyDateRange(moment(row.showTargetStart, dateFormat).unix() , moment(row.showTargetEnd, dateFormat).unix()) }
                          </MediumText>
                        )  
                        case 2: 
                        case 3:
                          return (
                            <MediumText fontWeight={tokens.typography.fontWeights.regular} as="p" title={formatOnlyDateRange(moment(row.showTargetStart, dateFormat).unix() , moment(row.showCompletion, dateFormat).unix()) }>
                              <i className="fal fa-calendar-clock"></i>
                              {formatOnlyDateRange(moment(row.showTargetStart, dateFormat).unix() , moment(row.showCompletion, dateFormat).unix()) }
                            </MediumText>
                          )     
                        default: 
                        return (
                          <MediumText fontWeight={tokens.typography.fontWeights.regular} as="p" title={formatOnlyDateRange(moment(row.showStart, dateFormat).unix() , moment(row.showEnd, dateFormat).unix()) }>
                            <i className="fal fa-calendar-clock"></i>
                            {formatOnlyDateRange(moment(row.showStart, dateFormat).unix() , moment(row.showEnd, dateFormat).unix()) }
                          </MediumText>
                        )     
                      }
                    } else {
                      return row?.start && row?.end ? (
                        <MediumText fontWeight={tokens.typography.fontWeights.regular} as="p" title={formatOnlyDateRange(row.start, row.end)}>
                          <i className="fal fa-calendar-days"></i>
                          {formatOnlyDateRange(row.start, row.end)}
                        </MediumText>
                      ) : (
                        "Invalid Date"
                      );
                    }
                  })()
                ) : (

                  <MediumText fontWeight={tokens.typography.fontWeights.regular} as="p" title={formatOnlyDateRange(row?.start, row?.end)}>
                    <i className="fal fa-calendar-days"></i>
                    {formatOnlyDateRange(row?.start, row?.end)}
                  </MediumText>
                )}
                
              </div>

            </div>
          </div>
        </div>
        <div className={`lecture-detail-top-right d-flex ${history.location.pathname.includes("shortCourse") ? "mentored__short__course" : "mentored__course"}`}>
          <ul className="lec-dtl-rgt-ul m-0 d-flex list-unstyled align-items-center flex-wrap">
            {(props.isAdmin != 1 && (row?.subject_type=="shortcourse" || row.subject_type=="mentored")) ?             
              <MentoredSubject subjectContent={props.subjectContent} row={row} updateSubject={props.updateSubject} /> 
            : null}
          </ul>
        </div>
      </div>      
    </>
  );
};
export default SubjectHeadBox;